export default {
  Confirm: 'Konfirmasi',
  Cancel: 'Batal',
  'The minimum time length is xxxs!': 'Panjang waktu minimal adalah {{num}}s!',
  'The maximum time length is 50s!': '最大时长为50s！',
  'Online service, no download required': 'Layanan online, tidak perlu mengunduh',
  'Add up to 20MB file': 'Tambahkan file hingga 20MB',
  'Support common formats': 'Mendukung format umum',
  'Best for general editing requirements': 'Paling baik untuk persyaratan pengeditan umum',
  '0 second wait': 'Tunggu 0 detik',
  'No size limits': 'Tanpa batas ukuran',
  'Support 1000+ formats': 'Mendukung 1000+ format',
  'Stable processing': 'Pemrosesan yang stabil',
  'Get access to HitPaw Toolkit!': 'Dapatkan akses HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Mendukung cut, crop & rotate, sesuaikan, kecepatan, tambahkan musik, stop motion, dll.',
  'The easiest video editing software for beginners':
    'Software pengeditan video termudah untuk pemula',
  'Remove watermark from videos and images in simple clicks':
    'Hilangkan watermark dari video dan gambar dengan beberapa klik',
  'TRY IT FREE': 'COBA GRATIS',
  'BUY NOW': 'BELI SEKARANG',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Analisa berhasil! File Anda lebih besar dari 100 MB sehingga tidak dapat diedit dengan HitPaw Online, silakan',
  'download the video': ' unduh video ',
  'and then use HitPaw Toolkit to proceed.':
    'dan kemudian gunakan HitPaw Toolkit untuk melanjutkan.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Potong 10 fragmen video paling banyak. Dapatkan HitPaw Toolkit untuk fitur lebih banyak.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'Ukuran file tidak boleh lebih dari 20MB. Dapatkan HitPaw Toolkit untuk fitur lebih banyak.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'Panjang waktu minimal adalah 1s! Dapatkan HitPaw Toolkit untuk fitur lebih banyak.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Tambah 3 video paling banyak. Dapatkan HitPaw Toolkit untuk fitur lebih banyak.',
  'This format is not supported currently.': 'Format ini tidak didukung saat ini.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Format ini tidak didukung saat ini. Dapatkan HitPaw Toolkit untuk fitur lebih banyak.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Gagal Membuat Video!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Gagal memuat!',
  'Are you sure you want to delete it?': 'Anda yakin ingin menghapusnya?',
  'Failed to extract the audio!': 'Gagal mengekstrak audio!',
  'Coming Soon': 'Segera hadir',
  'Learn more': 'Pelajari lebih lanjut',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Tambahkan hingga 2 file. Dapatkan HitPaw Toolkit untuk fitur lebih banyak.',
  Download: 'Unduh',
  'Try Again': 'Coba Lagi',
  Failed: 'Gagal',
  'Get Started': 'Memulai',
  Start: 'Mulai',
  End: 'Akhir',
  Export: 'Ekspor',
  'Your audio is ready!': 'Audio Anda sudah siap!',
  'Download Audio': 'Unduh Audio',
  YES: 'YA',
  'Export Failed': 'Ekspor Gagal',
  'Error occurs, the file cannot be added': 'Terjadi kesalahan, file tidak dapat ditambahkan',
  'Support merging audio files at most': 'Mendukung penggabungan maksimal {{num}} file audio',
  'Are you sure you want to delete this task?': 'Anda yakin ingin menghapus tugas ini?',
  Processing: 'Memproses',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Jangan lupa untuk mengunduh file Anda, file akan dihapus setelah 24 jam.',
  Uploading: 'Mengunggah',
  'Go Edit': 'Sunting',
  'Generate Files Successfully!': 'Berhasil Membuat File!',
  'Your order is being paid...': 'Pesanan Anda sedang dibayar',
  'Not yet': 'Belum',
  'Payment completed': 'Ya',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
